// SPA 数据分析:路由切换手动补发 page_view(gtag('config') 只在首屏发一次)。

interface AnalyticsWindow extends Window {
  gtag?: (...args: unknown[]) => void;
  clarity?: (...args: unknown[]) => void;
  GEODLE_GA_ID?: string;
}

export function pageview(path: string): void {
  const w = window as AnalyticsWindow;
  if (typeof w.gtag === 'function' && w.GEODLE_GA_ID) {
    w.gtag('event', 'page_view', {
      page_path: path,
      page_location: location.href,
      page_title: document.title,
    });
  }
  if (typeof w.clarity === 'function') {
    w.clarity('set', 'page', path);
  }
}
